export default __webpack_public_path__ + "session_sad.svg";